export default "__VITE_ASSET__BDGUBu4Y__"